import { CaseAnalyticsStateResource } from '@models/resource/case-analytics-state/case-analytics-state.resource';
import { ProductionJobStateResource } from '@models/resource/case-analytics-state/production-job-state.resource'; 
import { ReviewSetStateResource } from '@models/resource/case-analytics-state/review-set-state.resource';
import { UploadBatchStateResource } from '@models/resource/case-analytics-state/upload-batch-state.resource';
import { CaseAnalyticsState } from '@models/ui/case-analytics-state/case-analytics-state.model';
import { ProductionJobState } from '@models/ui/case-analytics-state/production-job-state.model';
import { ReviewSet } from '@models/ui/case-analytics-state/review-set.model';
import { ReviewSetState } from '@models/ui/case-analytics-state/review-set-state-model';
import { UploadBatchState } from '@models/ui/case-analytics-state/upload-batch-state.model';
import { MapperBase } from '../../utilities/mapper-base';
import { ReviewSetResource } from '@models/resource/review-set.resource';
import { UploadBatchResourceToUploadMapper } from './upload-batch-resource-to-upload.mapper';

const uploadBatchResourceToUpload = new UploadBatchResourceToUploadMapper();
class UploadBatchStateResourceToUploadBatchStateMapper extends MapperBase<UploadBatchStateResource, UploadBatchState> {
	map(source: UploadBatchStateResource): UploadBatchState {
		const dest = new UploadBatchState();
        dest.caseUploadBatchCount = source.caseUploadBatchCount;
        dest.totalDocCount = source.totalDocCount;
        dest.uploadBatches = uploadBatchResourceToUpload.mapCollection(source.uploadBatches);
		return dest;
	}
}

class ReviewSetResourceToReviewSetMapper extends MapperBase<ReviewSetResource, ReviewSet> {
	map(source: ReviewSetResource): ReviewSet {
		const dest = new ReviewSet();
        dest.id = source.reviewSetId;
        dest.caseId = source.caseId;
        dest.documentsInReview = source.documentsInReview;
        dest.remainingDocuments = source.remainingDocuments;
        dest.reviewedDocuments = source.reviewedDocuments;
        dest.totalDocuments = source.totalDocuments;
        dest.status = source.status;
        dest.title = source.title;
		return dest;
	}
}

const reviewSetResourceToReviewSet = new ReviewSetResourceToReviewSetMapper();
export class ReviewSetStateResourceToReviewSetStateMapper extends MapperBase<ReviewSetStateResource, ReviewSetState> {
	map(source: ReviewSetStateResource): ReviewSetState {
		const dest = new ReviewSetState();
        dest.caseReviewSetCount = source.caseReviewSetCount;
        dest.reviewSets = reviewSetResourceToReviewSet.mapCollection(source.reviewSets);
        dest.totalDocCount = source.totalDocCount;
		return dest;
	}
}

export class ProductionJobStateResourceToProductionJobStateMapper extends MapperBase<ProductionJobStateResource, ProductionJobState> {
	map(source: ProductionJobStateResource): ProductionJobState {
		const dest = new ProductionJobState();
        dest.caseProductionJobCount = source.caseProductionJobCount;
        dest.productionJobs = source.productionJobs;
        dest.totalDocCount = source.totalDocCount;
		return dest;
	}
}

const reviewSetStateResourceToReviewSetState = new ReviewSetStateResourceToReviewSetStateMapper();
const uploadBatchStateResourceToUploadBatchState = new UploadBatchStateResourceToUploadBatchStateMapper();
const productionJobStateResourceToProductionJob = new ProductionJobStateResourceToProductionJobStateMapper();
export class CaseAnalyticsStateResourceToCaseAnalyticsStateMapper extends MapperBase<CaseAnalyticsStateResource, CaseAnalyticsState> {
	map(source: CaseAnalyticsStateResource): CaseAnalyticsState {
		const dest = new CaseAnalyticsState();
        dest.caseId = source.caseId;
        dest.userFirstName = source.userFirstName;
        dest.reviewSetState = reviewSetStateResourceToReviewSetState.map(source.reviewSetState);
        dest.uploadBatchState = uploadBatchStateResourceToUploadBatchState.map(source.uploadBatchState);
        dest.productionJobState = productionJobStateResourceToProductionJob.map(source.productionJobState);
		return dest;
	}
}



